/* global axios */
import ApiClient from '../ApiClient';

class EvolutionApi extends ApiClient {
  constructor() {
    super('megachat/evolution_status', { accountScoped: true });
  }

  getInboxConfig(inboxId) {
    return axios.get(`${this.url}/inbox_config`, {
      params: { inbox_id: inboxId },
    });
  }

  checkConnection(inboxId) {
    return axios.get(`${this.url}/check_connection`, {
      params: { inbox_id: inboxId },
    });
  }

  getHistory(inboxId, limit = 15) {
    return axios.get(`${this.url}/history`, {
      params: { inbox_id: inboxId, limit },
    });
  }

  getRequestStatus(requestId) {
    return axios.get(`${this.url}/requests/${requestId}`);
  }

  create(payload) {
    const isFormData = payload instanceof FormData;

    return axios({
      method: 'post',
      url: this.url,
      data: payload,
      headers: isFormData
        ? {
            'Content-Type': 'multipart/form-data',
          }
        : undefined,
    });
  }
}

export default new EvolutionApi();
